export const habaCart = {
  habaVoucher: {
    title: 'Haben Sie einen Gutschein oder Vorteilscode?',
    coupon: 'Aktionscode',
    apply: 'Einlösen',
    placeholder: 'Nummer eingeben',
    error: 'Bitte geben Sie eine Gutscheinnummer ein',
    applyVoucherSuccess: '{{voucherCode}} wurde erfolgreich eingelöst.',
    removeVoucherSuccess: '{{voucherCode}} wurde entfernt.',
    availableCoupons: 'Einlösbare Coupons',
    availableCouponsLabel: 'Du kannst diese Coupons deiner Bestellung hinzufügen.',
    vouchersApplied: 'Eingelöste Gutscheine:',
    promotionInfo: {
      headline: 'Alle Informationen und Bedingungen',
      labelPromo: 'Vorteilscode',
      labelCampaign: 'Kampagne',
    },
  },
  habaMiniCart: {
    cart: 'Warenkorb',
    emptyCart: 'Warenkorb leer.',
    viewCart: 'Zum Warenkorb',
    title: 'Ihr Warenkorb',
    checkout: 'Zur Kasse',
    offer: {
      question: 'Benötigen Sie ein Angebot?',
      description:
        'Im Warenkorb können Sie einen Kostenvoranschlag zur Mittelbeantragung anfordern.',
    },
  },
  habaPopupCart: {
    headline: 'Artikel zum Warenkorb hinzugefügt',
    btn: {
      continue: 'Weiter Einkaufen',
      toCart: 'Zum Warenkorb',
    },
    recommendationsTitle: 'Produkte die Sie auch interessieren könnten',
  },
  habaCart: {
    cartChanged: 'Ihr Warenkorb wurde aktualisiert.',
    emptyCartDescription: 'Ihr Warenkorb ist leer.',
    myCart: 'Mein Warenkorb',
    toHome: 'Zurück zur Startseite',
    offer: {
      headline: 'Kostenvoranschlag zur Mittelbeantragung',
      info: 'Für eine Angebotsanfrage übermitteln wir Ihren aktuellen Warenkorb. Legen Sie bitte entsprechend alle Artikel (in entsprechender Konfiguration und mit den jeweiligen Mengen) in Ihren Warenkorb. Klicken Sie anschließend auf "Angebot anfordern" und Ihre Anfrage wird an unsere Mitarbeiter:innen übermittelt. Wir werden dann schnellstmöglich <a href="{{contactUrl}}" target="_blank">Kontakt</a> mit Ihnen aufnehmen.',
      button: 'Jetzt unverbindlich anfordern',
      //button: 'ZUR ANGEBOTSANFRAGE',
      label: 'Hinweis',
      body: {
        //info: 'Unser automatische Angebotsanfrage-Service ist wegen Wartungsarbeiten in Kürze wieder verfügbar. Ein Vorabangebot können Sie in der Zwischenzeit mit dem folgenden Link anfordern:',
        info: 'Für eine Angebotsanfrage werden die Produkte in Ihrem Warenkorb übermittelt:',
        login: 'Melden Sie sich in Ihrem Kundenkonto an',
        line1:
          'Starten Sie Ihre Angebotserstellung mit nur einem Klick auf „Jetzt unverbindlich anfordern“',
        line2: 'Unsere Mitarbeiter:innen werden schnellstmöglich Kontakt mit Ihnen aufnehmen.',
        success: 'Ihre Anfrage wurde erfolgreich übermittelt',
        line3: '( i ) Artikel mit Aktionspreisen können nicht einzeln berücksichtigt werden – es wird ihr regulärer Preis zugrunde gelegt.',
        line4: 'Selbstverständlich erhalten Sie von uns ein individuelles Angebot für Ihren gesamten Warenkorb.'
      },
      inputPlaceholder:
        'Wichtige Hinweise zu Ihrem Vorabangebot können Sie im Kommentarfeld hinterlegen.',
      successMessage: 'Ihre Anfrage wurde erfolgreich übermittelt',
      errorMessage: 'Ihre Anfrage konnte nicht übermittelt werden.',
      billingAddressHeadline: 'Rechnungsadresse hinzufügen',
      billingAddressInformation:
        'Um Ihnen ein unverbindliches Vorabangebot senden zu können benötigen wir eine aktuelle Rechnungsadresse.',
    },
    ociPunchoutError: 'Punchout-Bestellung konnte nicht erstellt werden',
    ociPunchoutMinCartError: 'Der Mindestbestellwert von {{value}} ist noch nicht erreicht.',
  },
  habaCartDetails: {
    title: 'Bestellübersicht',
    info: 'Ihren Aktionscode können Sie im Letzten Bestellschritt eingeben',
    productsValue: 'Warenwert',
    shippingValue: 'Versandkosten',
    freightValue: 'Frachtkosten',
    //TODO ASE Texte
    excludedFrightCost: 'zzgl. möglicher Frachtkosten',
    totalValue: 'Gesamtsumme',
    proceedToCheckout: 'Weiter zur Kasse',
    //TODO ASE Texte
    invalidCartError:
      'Die Gesamtsumme konnte nicht berechnet werden. Laden die die Seite neu, um den Bestellprozess fortführen zu können.',
    reloadCart: 'Seite neu laden',
    vat: 'enthaltene MwSt.',
    payment: 'So können Sie bezahlen',
    punchout: 'Bestellung übertragen',
    punchoutSuccess: 'Der Warenkorb wurde an Ihr Beschaffungssystem übertragen',
    punchoutError: 'Der Warenkorb konnte nicht in Ihr Beschaffungssystem übertragen werden',
    // new
    details: {
      initialPrice: 'Ursprünglicher Warenwert',
      reductions: 'Ihre Ersparnisse',
      currentPrice: 'Warenwert Netto',
      currentPriceDetails: '(alle Aktionen angewendet)',
      returnVoucher: 'Gutscheineinlösung',
      totalNet: 'Gesamt Netto',
      includingTva: 'gesetzliche MwSt.',
      deliveryCost: 'Versandkosten Brutto',
      freightCost: 'Frachtkosten Brutto',
      deliveryCostNet: 'Versandkosten Netto',
      freightCostNet: 'Frachtkosten Netto',
      totalBrut: 'Gesamtwert',
      helperTitle: 'Vorteilscode und Gutscheine können im letzten Schritt eingelöst werden.',
      energySurcharge: 'Energiezuschlag',
      energySurchargeInfo: 'Aufgrund gestiegener Energie- und Logistikkosten erheben wir vorübergehend einen Kostenzuschlag.'
    },
  },
  directOrderForm: {
    articleNumber: 'Artikelnummer',
    quantity: 'Menge',
    price: 'Preis',
    searchArticle: 'Artikel suchen',
    addMoreItems: 'Weitere Artikel hinzufügen',
    addItemsToCart: 'Artikel in den Warenkorb',
    viewAll: 'Alle Anzeigen',
    articlesFoundFor: '{{ number }} Ergebnisse für “{{ query }}”',
    articleCode: 'Artikelnummer: {{ code }}',
    choose: 'Auswählen',
    loadMore: 'Mehr laden',
    messageAddedToCart: 'Deine Artikel wurden zum Warenkorb hinzugefügt',
    noResults: 'Zu dieser Artikelnummer gibt es keinen passenden Artikel',
    unavailableProducts: 'Nicht verfügbare Produkte',
    unavailableProductsDescription:
      'Mindestens eines Ihrer hinzugefügten Produkte ist nicht mehr verfügbar.\nUm die Liste zum Warenkorb hinzuzufügen, müssen Sie die nicht mehr verfügbaren Produkte entfernen.',
    removeProducts: 'Produkt entfernen',
    reducedQuantityMessage:
      'Die hinzugefügte Menge für mindestens eines der hinzugefügten Produkte ist nicht mehr verfügbar.',
  },
};
